import { render, staticRenderFns } from "./vacaciones-card.vue?vue&type=template&id=6db0639c&scoped=true"
import script from "./vacaciones-card.vue?vue&type=script&lang=js"
export * from "./vacaciones-card.vue?vue&type=script&lang=js"
import style0 from "./vacaciones-card.vue?vue&type=style&index=0&id=6db0639c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db0639c",
  null
  
)

export default component.exports